import React from 'react';
import { Link } from 'react-router-dom';

const integrations = [
  {
    name: 'SAM.gov',
    description: 'Federal contract opportunities database',
    status: 'connected',
    icon: '🏛️',
  },
  {
    name: 'GSA eBuy',
    description: 'GSA schedule opportunities',
    status: 'available',
    icon: '🏢',
  },
  {
    name: 'SeaPort NxG',
    description: 'Navy contract vehicle',
    status: 'available',
    icon: '⚓',
  },
  {
    name: 'Zapier',
    description: 'Connect with 5000+ apps',
    status: 'available',
    icon: '⚡',
  },
  {
    name: 'Salesforce',
    description: 'CRM integration (Enterprise)',
    status: 'enterprise',
    icon: '☁️',
  },
];

const Integrations: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Integrations</h1>
        <p className="mt-1 text-gray-600">Connect your favorite tools and data sources</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {integrations.map((integration) => (
          <div key={integration.name} className="bg-white shadow rounded-lg p-6">
            <div className="flex items-start justify-between">
              <div className="text-4xl">{integration.icon}</div>
              <span
                className={`text-xs px-2 py-1 rounded-full ${
                  integration.status === 'connected'
                    ? 'bg-green-100 text-green-800'
                    : integration.status === 'enterprise'
                    ? 'bg-purple-100 text-purple-800'
                    : 'bg-gray-100 text-gray-800'
                }`}
              >
                {integration.status}
              </span>
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900">{integration.name}</h3>
            <p className="mt-1 text-sm text-gray-600">{integration.description}</p>
            <button
              className={`mt-4 w-full py-2 px-4 rounded-md text-sm font-medium ${
                integration.status === 'connected'
                  ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  : integration.status === 'enterprise'
                  ? 'bg-purple-100 text-purple-700'
                  : 'bg-brand-600 text-white hover:bg-brand-700'
              }`}
            >
              {integration.status === 'connected'
                ? 'Configure'
                : integration.status === 'enterprise'
                ? 'Enterprise Plan'
                : 'Connect'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Integrations;
